import heading from "./heading";

export default function access() {
  const target = document.querySelector(".is-access");

  if (!target) return;

  heading();
}
